// extracted by mini-css-extract-plugin
export default {"card":"Card_card__zxy-Y","deleteButton":"Card_deleteButton__hDbxQ","typeIcon":"Card_typeIcon__QjvxU","mask":"Card_mask__nned3"};